import { DocumentTemplateMatch, DocumentType } from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'document-template';

export class DocumentTemplateController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async matchDocumentTemplate(
    documentType: DocumentType,
    shipmentId: number,
  ): Promise<DocumentTemplateMatch> {
    const response = await this.http.get<DocumentTemplateMatch>(
      `match/${documentType}/${shipmentId}`,
    );
    return new DocumentTemplateMatch(response.data);
  }
}
